import ActionAttributeTableCell from '@/components/IndexTable/custom/cells/ActionAttributeTableCell.vue'
import ActionEmailTableCell from '@/components/IndexTable/custom/cells/ActionEmailTableCell.vue'
import ChannelsTableCell from '@/components/IndexTable/custom/cells/ChannelsTableCell.vue'
import DiagnosticLogActions from '@/components/IndexTable/custom/cells/DiagnosticLogActions.vue'
import AppRepositoryActions from '@/components/IndexTable/custom/cells/AppRepositoryActions.vue'
import GoTennaVersionCell from '@/components/IndexTable/custom/cells/GoTennaVersionCell.vue'
import OrganizationRadioSummaryActions from '@/components/IndexTable/custom/cells/OrganizationRadioSummaryActions.vue'
import RadioPremiumStatusCell from '@/components/IndexTable/custom/cells/RadioPremiumStatusCell.vue'
import SliderCell from '@/components/IndexTable/custom/cells/SliderCell.vue'
import UsersConfirmedCell from '@/components/IndexTable/custom/cells/UsersConfirmedCell.vue'
import UsersRolesCell from '@/components/IndexTable/custom/cells/UsersRolesCell.vue'
import RelayRadioStatusCell from '@/components/IndexTable/custom/cells/relays/RelayRadioStatusCell.vue'
import RelayImagesCell from '@/components/IndexTable/custom/cells/relays/RelayImagesCell.vue'
import RelayRadioLastResponseCell from '@/components/IndexTable/custom/cells/relays/RelayRadioLastResponseCell.vue'
import RelayRadioActions from '@/components/IndexTable/custom/cells/relays/RelayRadioActions.vue'
import RelayActions from '@/components/IndexTable/custom/cells/relays/RelayActions.vue'
import RelayDescriptionCell from '@/components/IndexTable/custom/cells/relays/RelayDescriptionCell.vue'
import HealthCheckMessagesReceivedCell from '@/components/IndexTable/custom/cells/relays/HealthCheckMessagesReceivedCell.vue'
import HealthCheckFrequenciesCell from '@/components/IndexTable/custom/cells/relays/HealthCheckFrequenciesCell.vue'
import HealthCheckAntennaCell from '@/components/IndexTable/custom/cells/relays/HealthCheckAntennaCell.vue'
import HealthCheckBatteryCell from '@/components/IndexTable/custom/cells/relays/HealthCheckBatteryCell.vue'
import HealthCheckTemperatureCell from '@/components/IndexTable/custom/cells/relays/HealthCheckTemperatureCell.vue'
import ConfigurationSetPliIntervalCell from '@/components/IndexTable/custom/cells/configuration-sets/PliIntervalCell.vue'
import ConfigurationSetActions from '@/components/IndexTable/custom/cells/configuration-sets/Actions.vue'
import ConfigurationSetDistributionStatusCell from '@/components/IndexTable/custom/cells/configuration-sets/ConfigurationSetDistributionStatusCell.vue'
import ConfigurationSetDistributionActions from '@/components/IndexTable/custom/cells/configuration-sets/ConfigurationSetDistributionActions.vue'
import FrequencySetTypeCell from '@/components/IndexTable/custom/cells/frequency-sets/TypeCell.vue'
import FrequencySetListCell from '@/components/IndexTable/custom/cells/frequency-sets/ListCell.vue'

export default {
    ActionAttributeTableCell,
    ActionEmailTableCell,
    ChannelsTableCell,
    DiagnosticLogActions,
    ConfigurationSetActions,
    ConfigurationSetPliIntervalCell,
    ConfigurationSetDistributionStatusCell,
    ConfigurationSetDistributionActions,
    FrequencySetTypeCell,
    FrequencySetListCell,
    AppRepositoryActions,
    GoTennaVersionCell,
    OrganizationRadioSummaryActions,
    RadioPremiumStatusCell,
    SliderCell,
    UsersConfirmedCell,
    UsersRolesCell,
    RelayRadioStatusCell,
    RelayImagesCell,
    RelayRadioLastResponseCell,
    RelayRadioActions,
    RelayDescriptionCell,
    RelayActions,
    HealthCheckMessagesReceivedCell,
    HealthCheckFrequenciesCell,
    HealthCheckAntennaCell,
    HealthCheckBatteryCell,
    HealthCheckTemperatureCell,
}
